"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const SchemaLayout = (_ref) => {
  let children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  const id = props.id,
        index = props.index,
        schema = props.schema,
        uiSchema = props.uiSchema,
        formData = props.formData,
        onPropertyChange = props.onPropertyChange,
        onChange = props.onChange,
        registry = props.registry;
  const formContext = registry.formContext; // uiOptions

  const uiOptions = (0, _utils.getUiOptions)(uiSchema);

  if (!uiOptions) {
    return children;
  } // uiLayout


  const uiLayout = (0, _utils.getUiLayout)(props); // settings and toolbar

  const changeProperty = (name, value) => {
    if (!schema.type === "object") {
      return false;
    }

    onChange(_extends({}, formData, {
      [name]: value
    }));
  }; // delete + restore


  const handleDelete = () => {
    if (uiLayout.deletable && uiLayout.restorable) {
      changeProperty("_action", "delete");
    } else if (props.hasRemove && props.onRemoveItem) {
      props.onRemoveItem();
    } else {
      props.onChange((0, _utils.getDefaultFormState)(schema, undefined));
    }
  };

  const handleRestore = () => {
    if (uiLayout.restorable) {
      changeProperty("_action", "restore");
    }
  }; // uiActions


  const uiActions = {
    onEdit: () => formContext.onEdit && formContext.onEdit(props),
    onSave: () => formContext.onSave && formContext.onSave(props),
    onToggle: () => formContext.onToggle && formContext.onToggle(props),
    onExpand: () => formContext.onExpand && formContext.onExpand(props),
    onCollapse: () => formContext.onCollapse && formContext.onCollapse(props),
    onAddItem: props.canAdd && props.onAddItem,
    onRemoveItem: props.hasRemove && props.onRemoveItem,
    onDelete: () => formContext.onDelete && formContext.onDelete(props) || uiLayout.deletable && handleDelete(),
    onRestore: () => formContext.onRestore && formContext.onRestore(props) || uiLayout.restorable && handleRestore(),
    onDialog: (event, button) => formContext.onDialog && formContext.onDialog(_extends({}, props, {
      button: button
    }), event),
    onUpload: event => formContext.onUpload && formContext.onUpload(props, event)
  }; // uiButtons

  const uiButtons = (0, _utils.getUiButtons)(_extends({}, props, {}, uiActions)); // uiMenu

  const uiMenu = (0, _utils.getUiMenu)(props);
  const uiSettings = (0, _utils.getUiSettings)(_extends({}, props, {
    onSettingsChange: changeProperty
  }));
  const uiToolbar = (0, _utils.getUiToolbar)(_extends({}, props, {}, uiLayout, {}, uiActions, {
    onSettingsChange: changeProperty
  })); // preview

  const uiPreview = (0, _utils.getUiPreview)(props); // get layout

  const layouts = registry.layouts; // || getDefaultRegistry()

  const layout = uiLayout.layout;
  let FieldLayout;

  if (layout && layouts[layout]) {
    FieldLayout = layouts[layout];
  } else if (layout) {
    return _react.default.createElement("p", null, "Layout ", layout, "\xA0does not exist.");
  } else {
    FieldLayout = layouts['field'];
  } // expandId + expandName


  const currentId = formContext.currentId,
        expandId = formContext.expandId,
        expandName = formContext.expandName,
        editId = formContext.editId,
        editName = formContext.editName,
        settingsId = formContext.settingsId,
        settingsName = formContext.settingsName; // uiFieldset

  const uiFieldset = (0, _utils.getUiFieldset)(props); // render fieldset

  const renderFieldset = (fieldset, index) => {
    const SchemaField = registry.fields.SchemaField; // name, selected

    const name = fieldset.name,
          selected = fieldset.selected; // part of navigation?

    const uiOptions = (0, _utils.getUiOptions)(uiSchema);

    if (uiOptions.nav && !selected) {
      return null;
    } // schema, uiSchema, formData


    const fieldId = fieldset && fieldset.id;
    const fieldSchema = fieldset && fieldset.schema;
    const fieldUiSchema = fieldset && fieldset.uiSchema;
    const fieldUiOptions = fieldset && fieldset.uiOptions;
    const fieldFormData = fieldset && fieldset.formData;
    /*
    */

    if (fieldSchema) {
      return _react.default.createElement(SchemaField, _extends({}, props, {
        key: index,
        name: name,
        id: fieldId,
        idPrefix: id,
        schema: fieldSchema,
        uiSchema: fieldUiSchema,
        formData: fieldFormData,
        isArrayItem: false,
        onChange: onPropertyChange(name)
      }));
    }

    if (fieldUiSchema && fieldUiOptions.fieldset) {
      return _react.default.createElement(SchemaField, _extends({}, props, {
        key: index,
        name: name,
        id: fieldId,
        idPrefix: id,
        uiSchema: fieldUiSchema,
        isArrayItem: false,
        onChange: onChange
      }));
    }

    return null;
  };

  return _react.default.createElement(FieldLayout, _extends({}, uiActions, uiLayout, uiPreview, {
    currentId: currentId,
    menu: uiMenu,
    buttons: uiButtons,
    settings: uiSettings,
    toolbar: uiToolbar,
    schema: schema,
    uiSchema: uiSchema,
    formData: formData,
    formContext: formContext
  }), uiFieldset && uiFieldset.map(renderFieldset) || children);
};

var _default = SchemaLayout;
exports.default = _default;
module.exports = exports.default;